import React from 'react';

import { Skeleton } from '@lumapps/play-player/components/Skeleton';
import { ImportOnVisibility } from '@lumapps/utils/components/ImportOnVisibility';

const LazyClientComputedPlay = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-play' */
            './ClientComputedPlay'
        ),
);

export const ClientComputedPlay = (props: React.ComponentProps<typeof LazyClientComputedPlay>) => (
    <ImportOnVisibility loadingFallback={<Skeleton />}>
        <LazyClientComputedPlay {...props} />
    </ImportOnVisibility>
);
